import cn from "classnames";
import type { JSX } from "react";
import { Link, NavLink } from "react-router-dom";
import { IconLock } from "./icons";
import { Tooltip } from "./tooltip";

const active = "bg-off-white font-semibold text-black";
const inactive = "hover:bg-black-50 text-black-500";
const navButton = "block p-2 rounded-md hover:no-underline";

export const navLink = ({ isActive }: { isActive: boolean }) =>
  cn(navButton, { [inactive]: !isActive, [active]: isActive });

const navRowClass = (isCurrent: boolean, hideName: boolean) =>
  cn(
    navButton,
    hideName ? "pl-2 pr-0" : "px-2",
    "py-2 rounded-md hover:no-underline",
    {
      [inactive]: !isCurrent,
      [active]: isCurrent,
    },
  );

export const LinkNav = ({
  icon,
  name,
  to,
  hideName = false,
  isActive,
}: {
  icon: JSX.Element;
  name: string;
  to: string;
  hideName?: boolean;
  isActive?: boolean;
}) => {
  const body = (
    <div className="flex items-center">
      <div className={hideName ? undefined : "mr-2"} aria-hidden="true">
        {icon}
      </div>
      {hideName ? null : <div>{name}</div>}
    </div>
  );

  if (isActive === undefined) {
    return (
      <NavLink
        className={({ isActive }) => navRowClass(isActive, hideName)}
        to={to}
        key={to}
      >
        {body}
      </NavLink>
    );
  }

  return (
    <Link
      className={navRowClass(isActive, hideName)}
      to={to}
      key={to}
      aria-current={isActive ? "page" : undefined}
    >
      {body}
    </Link>
  );
};

export const LinkNavDisabled = ({
  icon,
  name,
  tooltipText,
  hideName = false,
}: {
  icon: JSX.Element;
  name: string;
  tooltipText: string;
  hideName?: boolean;
}) => (
  <span
    className={cn(
      navButton,
      hideName ? "pl-2 pr-0" : "px-2",
      "py-2 rounded-md hover:no-underline",
      inactive,
    )}
  >
    <div className="flex items-center">
      <div className={hideName ? undefined : "mr-2"} aria-hidden="true">
        {icon}
      </div>
      {hideName ? null : (
        <div className="flex items-center">
          {name}
          <Tooltip text={tooltipText} fluid>
            <IconLock variant="sm" className="ml-1 opacity-60" />
          </Tooltip>
        </div>
      )}
    </div>
  </span>
);
